// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--+L18k";
export var checkmark = "checkbox-module--checkmark--oPlVj";
export var container = "checkbox-module--container--UORez";
export var errorBox = "checkbox-module--error-box--Up+zh";
export var input = "checkbox-module--input--v1d0n";
export var labelBox = "checkbox-module--label-box--kh2hn";
export var labelContent = "checkbox-module--label-content--6k07b";
export var light = "checkbox-module--light--o8Dpe";